import PersonalityCommunication from '~/pages/communication/personality/libs/components/PersonalityCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const PersonalityCommunicationPage = (props: TPageProps) => (
  <PersonalityCommunication {...props} />
)

export default PersonalityCommunicationPage
